
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/cloud-cms",
      function () {
        return require("private-next-pages/product/cloud-cms/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/cloud-cms"])
      });
    }
  